import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import classNames from 'classnames';
import * as ReactDOM from 'react-dom';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function GroupList(props) {
  const {
    groupList, setGroupList = () => {}, setOpenedGroup = () => {}, openedGroup = null, searchGroup = '',
  } = props;
  const [items, setItems] = useState(groupList);
  const [newIndex, setNewIndex] = useState(0);
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [styleGhost, setStyleGhost] = useState(null);
  const [targetElementId, setTargetElementId] = useState(null);
  const [targetPos, setTargetPos] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);
  const wrapperRef = useRef(null);
  const ghostRef = useRef(null);

  const blockHeight = 40;

  // useEffect(() => {
  //   const filteredGroupList = groupList?.filter(g => {
  //     return g.id.toLowerCase().includes(searchGroup.toLowerCase());
  //   }) || [];
  //   setItems(filteredGroupList);
  // }, [JSON.stringify(groupList), searchGroup]);

  useEffect(() => {
    setItems(groupList);
  }, [JSON.stringify(groupList)]);

  const calculateOrder = event => {
    const parentRect = wrapperRef.current.getBoundingClientRect();
    const relativeY = event.clientY - parentRect.top + wrapperRef.current.scrollTop;
    let hoverIndex = Math.floor(relativeY / blockHeight);
    const ost = relativeY % blockHeight;
    if (ost > blockHeight / 2) {
      hoverIndex++;
    }

    if (hoverIndex > targetIndex) {
      hoverIndex--;
    }
    hoverIndex = Math.max(0, Math.min(hoverIndex, groupList.length - 1));
    setNewIndex(hoverIndex);
    setVisibleIndex(hoverIndex <= targetIndex ? hoverIndex : hoverIndex + 1);
  };

  const onMouseDown = e => {
    if (searchGroup) return;
    const tId = e?.target?.parentElement?.parentElement?.id || '';
    const selected = groupList.find(g => g.id === tId);
    if (selected && !selected.disablePosition) {
      document.body.classList.add('drag-cursor');
      const targetRect = e.target.parentElement.parentElement.getBoundingClientRect();
      setTargetPos({
        y: e.clientY - targetRect.y,
        x: e.clientX - targetRect.x,
        top: targetRect.top,
        left: targetRect.left,
        width: targetRect.width,
        height: targetRect.height,
        scrollTop: wrapperRef.current.scrollTop,
      });
      setStyleGhost({
        top: `${targetRect.top}px`,
        left: `${targetRect.left}px`,
        width: `${targetRect.width}px`,
      });
      setTargetIndex(selected.sortIndex);
      setTargetElementId(tId);
      setTargetIndex(selected.sortIndex);
      setVisibleIndex(selected.sortIndex);
    }
  };

  const onMouseMove = event => {
    if (targetElementId && ghostRef?.current) {
      const top = event.clientY - targetPos.y;
      ghostRef.current.style.top = `${top}px`;
      ghostRef.current.style.left = `${targetPos.left}px`;
      ghostRef.current.style.width = `${targetPos.width}px`;
      setStyleGhost({
        top: `${top}px`,
        left: `${targetPos.left}px`,
        width: `${targetPos.width}px`,
      });
      calculateOrder(event);
    }
  };

  const onMouseUp = e => {
    if (!targetElementId) return;
    document.body.classList.remove('drag-cursor');
    const newGroups = [...items]
      .sort((a, b) => a.sortIndex - b.sortIndex);
    const [movedItem] = newGroups.splice(targetIndex, 1);
    newGroups.splice(newIndex, 0, movedItem);
    const updatedGroups = newGroups.map((item, index) => ({
      ...item,
      sortIndex: index,
    }));

    setTargetPos(null);
    setTargetElementId(null);
    setTargetIndex(null);
    setVisibleIndex(null);
    setGroupList(updatedGroups);
  };

  const handleGroupChange = useCallback(group => {
    const newGroup = [...groupList];
    const index = groupList.findIndex(g => g.id === group.id);
    const isEnable = !!newGroup[index]?.enable;
    newGroup[index]?.children.map(c => {
      c.enable = !isEnable;
      if (c?.options?.length) {
        c.options = c?.options.map(o => ({ ...o, enable: !isEnable }));
      }
      return c;
    });
    newGroup[index].enable = !isEnable;
    setOpenedGroup(newGroup[index].id);
    setGroupList(newGroup);
  }, [groupList]);

  const renderItem = (group, key) => {
    const isGroupEnable = group?.enable;
    const isEvery = group.children.every(c => c.enable);
    const isSome = group.children.some(c => c.enable) && !isEvery && isGroupEnable;
    return (
      <div
        key={group.id}
        className={classNames('available-field', { opened: openedGroup === group.id }, group?.className || '')}
        style={{
          top: group.sortIndex * blockHeight,
          ...group.style,
        }}
        id={group.id}
        ref={group?.ghostRef || null}
      >
        <div className="available-group-name">
          <div className="group-check">
            <CheckBoxInputWithLabel
              type="text"
              inputClassName={classNames({ 'some-child': isSome })}
              name={`group-${key}`}
              label={group.groupName}
              withLabel
              addPlaceholder
              inputProps={{
                value: isGroupEnable,
                onChange: () => handleGroupChange(group),
              }}
            />
          </div>
          <div
            className="group-toggle-drag"
            onMouseDown={onMouseDown}
          >
            <Icons customIcon width={24} height={24} icon="draggable" />
          </div>
          <div
            className="group-toggle-select"
            onClick={() => setOpenedGroup(openedGroup !== group.id ? group.id : null)}
          >
            <Icons customIcon className="select-arrow" width={14} height={14} icon="arrow-down" />
          </div>
        </div>
      </div>
    );
  };

  function TargetElement() {
    if (!targetElementId || !targetPos || !styleGhost?.top) return null;
    const elem = groupList.find(g => g.id === targetElementId);
    if (!elem) return null;
    const ghostProps = {
      ...elem,
      className: 'ghost',
      style: styleGhost,
      id: `ghost-${targetElementId}`,
      ghostRef,
    };
    return ReactDOM.createPortal(renderItem(ghostProps, 'ghost'), document.body);
  }

  return (
    <div className={classNames('draggable-fields-wrapper custom-scroll-theme', { 'disable-drag': searchGroup })}>
      <div
        className="draggable-fields"
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        ref={wrapperRef}
      >
        {targetElementId && visibleIndex >= 0 && (<div className="insert-line" style={{ top: visibleIndex * blockHeight }} />)}
        {items.map(renderItem)}
        <TargetElement />
      </div>
    </div>
  );
}
